/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-22T14:43:04.498
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'rentmanage-rentplaceorder-'

export default 
{
path: '/rentmanage/rentplaceorder',
name: 'rentmanage-rentplaceorder',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}rentplaceorder-index',

meta:{
...meta,
title: '预订管理'
},

component: () => import('@/pages/rentmanage/rentplaceorder/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}rentplaceorder-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '预订管理编辑'
},

component: () => import('@/pages/rentmanage/rentplaceorder/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}rentplaceorderdetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '预订管理新增'
},

component: () => import('@/pages/rentmanage/rentplaceorder/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}rentplaceorderView',
auth: [
'hidden'
],

meta:{
...meta,
title: '预订管理详情查看'
},

component: () => import('@/pages/rentmanage/rentplaceorder/detail-view') ,
},
]
};
